import { Box, Card, BoxProps, CardProps } from '@mantine/core';
import cn from 'clsx';

export function ContentCard({
  children,
  wrapperProps,
  cardProps,
  withBgGradient = false,
}: {
  children: React.ReactNode;
  wrapperProps?: BoxProps;
  cardProps?: CardProps;
  withBgGradient?: boolean;
}) {
  return (
    <Box w={600} mx="auto" className="relative max-w-full" {...wrapperProps}>
      <Card
        {...cardProps}
        className={cn('z-10 p-6 lg:p-6 bg-[#0F1012]', cardProps?.className)}
      >
        {children}
      </Card>

      {withBgGradient && (
        <div
          className={cn(
            'absolute left-[40px] top-[60px]',
            'w-[calc(100%-80px)] h-[calc(100%-120px)]',
            'bg-[radial-gradient(ellipse_at_center,var(--mantine-color-brand-1)_0%,var(--mantine-color-brand-1)_10%,transparent_100%)] blur-[100px]'
          )}
        />
      )}
    </Box>
  );
}
